/* eslint-disable prefer-arrow/prefer-arrow-functions */
export {};

declare global {
    interface PromiseConstructor {
        sequence: (chain: Promise<any>[]) => Promise<any>;
    }
}

Promise.sequence = function(chain: Promise<any>[]) {
    const results: Promise<any>[] = [];
    const entries = chain.entries();

    return new Promise((yes, no) => {
        const next = () => {
            const entry = entries.next();

            if (entry.done) {
                yes(results);
            } else {
                results.push(entry.value[1].then(next, function() {
                    no(results);
                } ));
            }
        };
        next();
    });
};
